import { Link } from "react-router-dom";
import { Phone, Gamepad2 } from "lucide-react";
import { T } from "@/components/T";

export function FinalCtaSection() {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden grain-overlay" style={{ background: "#0b0c0e" }}>
      <div className="absolute inset-0 z-0">
        <img loading="lazy" src="/assets/fotos/hb-foto-5.webp" alt="" className="w-full h-full object-cover"
          style={{ opacity: 0.12, objectPosition: "center top" }} />
        <div className="absolute inset-0" style={{ background: "rgba(11,12,14,0.65)" }} />
      </div>
      <div className="absolute inset-0 flex items-center overflow-hidden pointer-events-none select-none z-[1]">
        <span className="font-bebas text-hb-yellow/[0.04] leading-none whitespace-nowrap pl-8"
          style={{ fontSize: "clamp(120px, 22vw, 300px)" }}>
          <T de="ANFRAGE" it="RICHIESTA" />
        </span>
      </div>
      <div className="absolute bottom-0 right-0 w-96 h-96 pointer-events-none z-[1]"
        style={{ background: "radial-gradient(ellipse at bottom right, rgba(245,200,0,0.04) 0%, transparent 70%)" }} />
      <div className="container-hb py-32 md:py-44 relative z-10">
        <div className="max-w-2xl">
          <span className="label-text block mb-8 reveal" style={{ color: "rgba(245,200,0,0.4)" }}>
            <T de="Nächster Schritt" it="Prossimo passo" />
          </span>
          <h2 className="font-bebas text-white mb-8 reveal reveal-delay-1"
            style={{ fontSize: "clamp(56px, 8vw, 110px)", lineHeight: 0.95 }}>
            <T de={<>Lassen Sie uns<br />Ihr Projekt<br /><span className="text-hb-yellow">besprechen.</span></>}
               it={<>Parliamo del<br />vostro progetto.<br /><span className="text-hb-yellow">Insieme.</span></>} />
          </h2>
          <p className="text-sm md:text-base font-inter mb-12 max-w-sm leading-relaxed reveal reveal-delay-2" style={{ color: "rgba(255,255,255,0.42)" }}>
            <T de="Erzählen Sie uns, was Sie vorhaben. Wir melden uns persönlich – ehrlich, kompetent, ohne Verpflichtung."
               it="Raccontateci cosa avete in mente. Vi risponderemo personalmente – in modo onesto, competente e senza impegno." />
          </p>
          <div className="flex flex-col sm:flex-row gap-4 reveal reveal-delay-3">
            <Link to="/kontakt" data-testid="main-cta-btn" className="btn-primary">
              <T de="Jetzt Anfrage senden" it="Invia una richiesta ora" />
            </Link>
            <a href="tel:+390473238030" data-testid="phone-cta-btn"
              className="text-xs tracking-widest uppercase font-semibold px-8 py-4 transition-all duration-300 font-inter inline-flex items-center gap-2"
              style={{ border: "1px solid rgba(245,200,0,0.22)", color: "rgba(255,255,255,0.5)" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(245,200,0,0.6)"; e.currentTarget.style.color = "#f5c800"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(245,200,0,0.22)"; e.currentTarget.style.color = "rgba(255,255,255,0.5)"; }}>
              <Phone size={12} /> +39 0473 238 030
            </a>
          </div>
          <p className="text-[10px] font-inter mt-8 tracking-wider reveal" style={{ color: "rgba(255,255,255,0.15)" }}>
            <T de="Mo – Fr · 7:00 – 18:00 Uhr · Holzbuddy Team · Hafner EC GmbH · Meran, Südtirol"
               it="Lun – Ven · 7:00 – 18:00 · Team Holzbuddy · Hafner EC GmbH · Merano, Alto Adige" />
          </p>
          <Link
            to="/spiel"
            data-testid="final-cta-spiel"
            className="inline-flex items-center gap-2 mt-10 transition-all duration-300 reveal"
            style={{ color: "rgba(245,200,0,0.22)", fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", fontFamily: "Inter, sans-serif", fontWeight: 600 }}
            onMouseEnter={e => { e.currentTarget.style.color = "rgba(245,200,0,0.6)"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "rgba(245,200,0,0.22)"; }}
          >
            <Gamepad2 size={12} />
            <T de="Holztetris spielen" it="Gioca a Holztetris" />
          </Link>
        </div>
      </div>
    </section>
  );
}
